<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <!-- Header Section -->
      <div class="header-section d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 class="review-title">Review Details - {{ lead?.name }}</h5>
        </div>
        <div class="header-actions">
          <button type="button" 
                  class="btn btn-outline-primary btn-sm"
                  *ngIf="!editMode"
                  (click)="toggleEditMode()">
            <i class="fas fa-edit me-1"></i>
            Edit Selected Fields
          </button>
           <button type="button" 
                  class="btn btn-success btn-sm"
                  *ngIf="editMode"
                  (click)="canceledit()" style="margin-right: 10px; background-color:#6c757d; border-color: #6c757d;">
            <i class="fas fa-close me-1"></i>
            Cancel
          </button>
          <button type="button" 
                  class="btn btn-success btn-sm"
                  *ngIf="editMode"
                  (click)="saveChanges()">
            <i class="fas fa-save me-1"></i>
            Save Changes
          </button>
        </div>
      </div>

      <!-- Review Form -->
      <form [formGroup]="reviewForm" class="review-form">
        <!-- Selected Fields Display - 2 Column Layout -->
        <div class="selected-fields-section mb-4">
          <h6 class="section-title mb-3">Selected Information</h6>
          
          <div class="row">
            <div class="col-md-6" *ngFor="let field of selectedFields; let i = index">
              <div class="field-item mb-3">
                <div class="field-wrapper">
                  <label class="field-label fw-bold">
                    {{ getFieldLabel(field) }}
                    <span class="text-danger" *ngIf="field === 'name' || field === 'email'">*</span>
                  </label>
                  
                  <!-- Display Mode -->
                  <div *ngIf="!editMode" class="field-value">
                    {{ getFieldValue(field) || 'N/A' }}
                  </div>
                  
                  <!-- Edit Mode -->
                  <div *ngIf="editMode" class="field-input">
                    <!-- Email Field -->
                    <input *ngIf="field === 'email'" 
                           type="email" 
                           class="form-control"
                           [class.is-invalid]="hasFieldError(field)"
                           [formControlName]="field">
                    
                    <!-- Phone Field -->
                    <input *ngIf="field === 'phone'" 
                           type="text" 
                           class="form-control"
                           [class.is-invalid]="hasFieldError(field)"
                           [formControlName]="field"
                           placeholder="Enter 10-digit phone number">
                    
                    <!-- Status Field -->
                    <select *ngIf="field === 'status'" 
                            class="form-select"
                            [class.is-invalid]="hasFieldError(field)"
                            [formControlName]="field">
                      <option value="">Select Status</option>
                      <option value="active">Active</option>
                      <option value="contacted">Contacted</option>
                      <option value="qualified">Qualified</option>
                      <option value="converted">Converted</option>
                      <option value="lost">Lost</option>
                    </select>
                    
                    <!-- Other Text Fields -->
                    <input *ngIf="field !== 'email' && field !== 'phone' && field !== 'status'" 
                           type="text" 
                           class="form-control"
                           [class.is-invalid]="hasFieldError(field)"
                           [formControlName]="field">
                    
                    <!-- Field Error Display -->
                    <div *ngIf="hasFieldError(field)" class="invalid-feedback">
                      {{ getFieldError(field) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Message Section (Always available, not tied to edit mode) -->
        <div class="message-section mb-4">
          <h6 class="section-title mb-3">Additional Information</h6>
          
          <div class="message-wrapper">
            <label class="field-label fw-bold" style="margin-bottom: 10px;">
              Add a Message 
              <span class="text-muted">(Optional)</span>
            </label>
            
            <div class="field-input">
              <textarea class="form-control message-textarea"
                        formControlName="message"
                        placeholder="Enter any additional information or notes..."
                        rows="4"
                        maxlength="250"></textarea>
              
              <div class="char-count mt-1">
                <small class="text-muted">
                  {{ messageCharCount }}/250 characters
                </small>
              </div>
              
              <div *ngIf="reviewForm.get('message')?.errors?.['maxlength']" 
                   class="text-danger small mt-1">
                Message cannot exceed 250 characters
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- Action Buttons -->
      <div class="action-buttons mt-4">
        <div class="d-flex justify-content-center gap-3">
          <button type="button" 
                  class="btn btn-secondary"
                  (click)="onBack()">
            <i class="fas fa-arrow-left me-1"></i>
            Back
          </button>
          
          <button type="button" 
                  class="btn btn-outline-secondary"
                  (click)="onCancel()">
            <i class="fas fa-times me-1"></i>
            Cancel
          </button>
          
          <button type="button" 
                  class="btn btn-primary"
                  (click)="generatePDF()"
                  [disabled]="isGeneratingPDF">
            <i class="fas fa-file-pdf me-1"></i>
            <span *ngIf="!isGeneratingPDF">Save As PDF</span>
            <span *ngIf="isGeneratingPDF">Generating PDF...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>